<template>
  <div class="modal" uk-modal>
    <div class="uk-modal-dialog">
      <button v-if="closeButton"
              class="uk-modal-close-default"
              type="button"
              uk-close></button>

      <div class="uk-modal-header" v-if="showHeader">
        <slot name="header">
          <h2 class="uk-modal-title">{{title}}</h2>
        </slot>
      </div>

      <slot v-if="playground" />
      <div v-else>
        <div class="uk-modal-body" :uk-overflow-auto="autoOverflow">
          <slot />
        </div>
        <div class="uk-modal-footer uk-text-right" v-if="showFooter">
          <slot name="footer">
            <slot name="buttons" />
            <common-button @click="hide">
              {{$t('close')}}
            </common-button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkitComponentWrapper from '@/mixins/UIkitComponentWrapper';
import CommonButton from './CommonButton';

export default {
  name: 'modal',
  mixins: [
    UIkitComponentWrapper({
      name: 'modal',
      props: ['bgClose', 'center', 'escClose', 'stack'],
      events: ['beforeshow', 'show', 'shown', 'beforehide', 'hide', 'hidden'],
      delegate: ['show', 'hide', 'toggle'],
    }),
  ],
  components: {
    CommonButton,
  },
  props: {
    title: String,
    autoOverflow: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    escClose: {
      type: Boolean,
      default: true,
    },
    bgClose: {
      type: Boolean,
      default: true,
    },
    center: {
      type: Boolean,
      default: false,
    },
    stack: {
      type: Boolean,
      default: false,
    },
    playground: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showHeader() {
      return this.$slots.header || this.title;
    },
    showFooter() {
      return this.$slots.footer || this.closeButton;
    },
  },
  i18n: {
    messages: {
      de: {
        close: 'Schließen',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// Modal.vue?602eb810